import { render, staticRenderFns } from "./CompetitionListVideoLayout.vue?vue&type=template&id=f1a25964&scoped=true&"
import script from "./CompetitionListVideoLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionListVideoLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a25964",
  null
  
)

export default component.exports